import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit, Output, EventEmitter, AfterViewChecked } from '@angular/core';
import { Import } from 'src/app/models/import';
import { ImportIssue } from 'src/app/models/importIssue';
import { DisplayNotificationService } from 'src/app/shared/services/common/notification.service';
import { ReadConfigService } from 'src/app/shared/services/common/read-config.service';
import { ImportService } from 'src/app/shared/services/payroll/import.service';
import { PayrollRecordComponent } from '../payroll-record/payroll-record.component';

@Component({
  selector: 'app-payroll-summary',
  templateUrl: './payroll-summary.component.html',
  styleUrls: ['./payroll-summary.component.css']
})
export class PayrollSummaryComponent implements OnInit, AfterViewChecked {

  private importRecord: Import;
  errorCount = 0;
  issueCount = 0;
  config: any;
  importErrors: any[];
  importError: any;
  importIssues: ImportIssue[];
  importIssue: ImportIssue;
  deleteRecordDialog = false;
  dataUploadSuccessMsg: any;
  paymentIncompleteMsg: any;
  paymentSuccessMsg: any;

  @Input()
  set import(selectedImport: Import) {
    this.importRecord = selectedImport;
    this.loadIssues();
    this.loadErrors();
  }

  get import(): Import { return this.importRecord; }
  @Input() payrollRecordsGrid: PayrollRecordComponent;
  @Output() isError: EventEmitter<boolean> = new EventEmitter();

  constructor(private importService: ImportService,
    private readConfigService: ReadConfigService,
    private notificationService: DisplayNotificationService) { }

  ngOnInit() {
    this.config = this.readConfigService.getPayrollUploadFile();
    this.dataUploadSuccessMsg = this.config.DataUploadSuccessMsg;
    this.paymentIncompleteMsg = this.config.PaymentIncompleteMsg;
    this.paymentSuccessMsg = this.config.PaymentSuccessMsg;
  }

  ngAfterViewChecked() {
    if (this.importRecord) {
      const element = document.getElementById('main-header');
      const positionInfoHeader = element.getBoundingClientRect();
      const elementFooter = document.getElementById('main-footer');
      const positionInfoFooter = elementFooter.getBoundingClientRect();
      const elementhstry = document.getElementById('history-container');
      const positionInfohstry = elementhstry.getBoundingClientRect();
      const elementStrock = document.getElementById('stroke-separator');
      const positionInfoStrock = elementStrock.getBoundingClientRect();
      const elementSumHeader = document.getElementById('summary-header');
      const positionInfoSumHeader = elementSumHeader.getBoundingClientRect();
      const headAndFootHeight = positionInfoHeader.height + positionInfoFooter.height;
      const historyContainerHeight = positionInfohstry.height + positionInfoStrock.height + positionInfoSumHeader.height;
      const elementsHeight = ((headAndFootHeight + historyContainerHeight) + 22);
      const overAllHeight = document.documentElement.clientHeight;
      const remaningHeight = overAllHeight - elementsHeight;
      const screenWidth = screen.width;
      if (screenWidth > 992.98) {
        document.getElementById('summary-data').style.maxHeight = remaningHeight + 'px';
      } else {
        document.getElementById('summary-data').style.maxHeight = 'inherit';
      }
    }
  }

  loadIssueRecords(issueType: string, isError: boolean = false) {
    if (issueType !== undefined) {
      const staging = this.importRecord.submitted === null;
      this.payrollRecordsGrid.loadIssueRecords(issueType, this.importRecord.id, staging, isError);
    }
  }

  loadErrors() {
    if (this.importRecord !== undefined && this.importRecord.submitted !== undefined) {
      const id = this.importRecord.id;
      this.importService.getImportErrors(id)
        .subscribe(importErrors => {
          this.importErrors = importErrors;
          const errorRcds = this.importErrors.filter(x => x.errorName === 'Total Records With Errors');
          this.errorCount = errorRcds[0].errorCount;
          this.isError.emit(this.errorCount > 0);
        },
          (error) => {
            console.log(error);
            this.notificationService.setErrorNotification();
          });
    }
  }

  loadIssues(): void {
    if (this.importRecord !== undefined) {
      const id = this.importRecord.id;
      this.importService.getIssues(id)
        .subscribe(importIssues => {
          this.importIssues = importIssues;
          const issueRecords = this.importIssues.filter(x => x.issueName === 'Total Issues');
          this.issueCount = issueRecords[0].issueCount;
        },
          (error: HttpErrorResponse) => {
            console.log(error);
            this.notificationService.setErrorNotification();
          });
    }
  }

}
